// extracted by mini-css-extract-plugin
export default {"modalscreen":"ModalScreen_modalscreen__hUCoF"};